import { UtilService } from '../../shared/util/util.service';
import { ObservationService } from '../../shared/observation/observation.service';
import { SelectItem } from 'primeng/api';
import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { CertificationTypeDto } from '../shared/dto/certification-type.dto';
import { Component, OnInit, Input } from '@angular/core';
import { ProfileCertificationService } from 'src/app/profiles/shared/profile-certification.service';
import { ProfileCertificationTypeDto } from '../../profiles/shared/dto/profile-certification-type.dto';
import { CertificationTypeService } from '../shared/certification-type.service';

@Component({
  selector: 'wl-certification-edit-dialog',
  templateUrl: './certification-edit-dialog.component.html',
  styleUrls: ['./certification-edit-dialog.component.less'],
    standalone: false
})
export class CertificationEditDialogComponent implements OnInit {
  @Input() profileId: number;
  @Input() certification: ProfileCertificationTypeDto;
  @Input() show: boolean;

  public certificationTypes: CertificationTypeDto[] = [];

  private _originalReinstatedDate: Date;

  constructor(
    private _profileCertificationService: ProfileCertificationService,
    private _certificationTypeService: CertificationTypeService,
    private _observationService: ObservationService
  ) {}

  ngOnInit(): void {
    this.certification = {} as ProfileCertificationTypeDto;

    this._certificationTypeService.getAllCertificationTypes().then((data: PagedResultGeneric<CertificationTypeDto>) => {
      this.certificationTypes = data.Result;
    });
  }

  ngOnChanges() {
    if (this.certification?.ProfileCertificationTypeID) {
      this._originalReinstatedDate = this.certification.ReinstatedDate;
    }
  }

  public cancel() {
    this.show = false;
  }

  public save() {
    if (!this.certification.ProfileCertificationTypeID) {
      this.certification.CertificationDate = new Date(this.certification.CertificationDate.setHours(12, 0, 0, 0));
      this._profileCertificationService.create(this.certification).then(() => {
        this._observationService.profileUpdated(this.profileId);
        this.show = false;
      });
    } else {
      this._profileCertificationService.update(this.certification).then(() => {
        if (this._originalReinstatedDate && this._originalReinstatedDate !== this.certification.ReinstatedDate) {
          this._profileCertificationService.renewCertification(this.certification.ProfileCertificationTypeID).then(() => {
            this._observationService.profileUpdated(this.profileId);
            this.show = false;
          });
        } else {
          this._observationService.profileUpdated(this.profileId);
          this.show = false;
        }
      });
    }
  }
}
